/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface LoginRefreshRequestContent
 */
export interface LoginRefreshRequestContent {
    /**
     * A longer-lived token that can be used to refresh the bearer token
     * @type {string}
     * @memberof LoginRefreshRequestContent
     */
    refreshToken: string;
}


/**
 * Check if a given object implements the LoginRefreshRequestContent interface.
 */
export function instanceOfLoginRefreshRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "refreshToken" in value;
    return isInstance;
}

export function LoginRefreshRequestContentFromJSON(json: any): LoginRefreshRequestContent {
    return LoginRefreshRequestContentFromJSONTyped(json, false);
}

export function LoginRefreshRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginRefreshRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'refreshToken': json['refreshToken'],
    };
}

export function LoginRefreshRequestContentToJSON(value?: LoginRefreshRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'refreshToken': value.refreshToken,
    };
}

